module.exports = __webpack_public_path__ + "static/media/back.a67e38c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/back.png
// module id = 122
// module chunks = 0